if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        const variantInput = this.form.querySelector('[name="id"]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        try {
          const formData = new FormData(this.form);

          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add this item to cart.'
            );
          }

this.showStitchesAddedBar();

this.updateStitchesCartIcon();

          this.error = false;
        } catch (error) {
          console.error('Stitches add to cart error:', error);

          this.error = true;

          this.handleErrorMessage(
            error.message || 'Unable to add this item to cart.'
          );
        } finally {
          this.submitButton.classList.remove('loading');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) {
            spinner.classList.add('hidden');
          }
        }
      }

      async updateStitchesCartIcon() {
        try {
          const response = await fetch('/cart.js', {
            headers: {
              Accept: 'application/json',
            },
          });

          const cart = await response.json();

          const cartIcon = document.querySelector('.st-cart-icon');

          if (!cartIcon) return;

          let dot = cartIcon.querySelector('.st-cart-count');

          if (cart.item_count > 0) {
            if (!dot) {
              dot = document.createElement('span');
              dot.className = 'st-cart-count';
              cartIcon.appendChild(dot);
            }

            dot.textContent = '';
          } else if (dot) {
            dot.remove();
          }

          cartIcon.setAttribute(
            'aria-label',
            cart.item_count > 0
              ? `Cart, ${cart.item_count} items`
              : 'Cart'
          );
        } catch (error) {
          console.error('Cart icon update error:', error);
        }
      }

      showStitchesAddedBar() {
        let bar = document.getElementById('stitches-added-bar');

        if (!bar) {
          bar = document.createElement('div');

          bar.id = 'stitches-added-bar';

          bar.innerHTML = `
            <div class="stitches-added-bar__content">
              <span>Item added to your cart</span>

              <a href="${routes.cart_url}">
                View cart
              </a>

              <button
                type="button"
                aria-label="Close"
              >
                ×
              </button>
            </div>
          `;

          document.body.appendChild(bar);

          const closeButton = bar.querySelector('button');

          closeButton.addEventListener('click', () => {
            bar.classList.remove('is-visible');
          });
        }

        clearTimeout(window.stitchesAddedBarTimer);

        bar.classList.remove('is-visible');

        void bar.offsetWidth;

        bar.classList.add('is-visible');

        window.stitchesAddedBarTimer = setTimeout(() => {
          bar.classList.remove('is-visible');
        }, 3500);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}